import React from "react";
import * as yup from "yup";
import { useFieldArray, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import FormTextInput from "../../components/common/text-input/form-text-input.component";
import { useDispatch } from "react-redux";
import { addInventories } from "../../redux/actions/inventory.action";
import { useHistory } from "react-router-dom";
import showToastMessage from "../../global/showToastMessage";

const itemSchema = yup.object().shape({
	category_set: yup.array().of(
		yup.object().shape({
			name: yup.string().required("required"),
			other_details: yup
				.object()
				.shape({ description: yup.string().required("required") }),
		})
	),
});

function AddInventoryCategory() {
	const dispatch = useDispatch();
	const history = useHistory();

	const { register, errors, control, handleSubmit } = useForm({
		defaultValues: {
			category_set: [
				{
					name: "",
					other_details: { description: "" },
				},
			],
		},
		mode: "onSubmit",
		resolver: yupResolver(itemSchema),
	});

	const { fields, append, remove } = useFieldArray({
		control,
		name: "category_set",
	});

	const _saveInventoryCategory = async (data) => {
		if (localStorage.getItem("location_id") === null) {
			showToastMessage(
				"Venue not selected. Please return to inventory page and select venue",
				"W"
			);
			return;
		}
		data["inventories"] = [];
		data["location_id"] = localStorage.getItem("location_id");
		let status = await dispatch(addInventories(data));
		if (status) {
			_back();
		}
	};

	const addItem = () => {
		append({
			name: "",
			other_details: { description: "" },
		});
	};
	const _back = () => {
		history.push({
			pathname: "/inventory",
			state: {
				tab: 1,
			},
		});
	};

	return (
		<div className="main-container">
			<div className="profile-navigation-container">
				<div className="profile-path">
					<span
						onClick={() => _back()}
						className="previous-page-path"
					>
						Inventory
					</span>{" "}
					&gt;{" "}
					<span className="current-page-path">Add Bulk Category</span>
				</div>
			</div>
			<div className="inner-container button mt-52px">
				<button className="button-primary" onClick={() => addItem()}>
					Add
				</button>
			</div>
			<div className="inner-container full">
				<table className="table-container">
					<thead>
						<tr>
							<td className="table-header">
								<div className="table-header-container">
									Category Name
								</div>
							</td>
							<td className="table-header ">
								<div className="table-header-container">
									Category Description
								</div>
							</td>
							<td className="" style={{ width: "4%" }}></td>
						</tr>
					</thead>
					<tbody>
						{fields.map((item, i) => (
							<tr key={item.id}>
								<td>
									<FormTextInput
										type="text"
										placeholder="Category Name"
										variant="form-lg"
										name={`category_set[${i}].name`}
										ref={register()}
										error={
											errors?.category_set?.[i]?.name
												?.message
										}
										defaultValue={item.name}
									/>
								</td>
								<td>
									<FormTextInput
										placeholder="Category Description"
										variant="form-lg"
										type="text"
										name={`category_set[${i}].other_details.description`}
										ref={register()}
										error={
											errors?.category_set?.[i]
												?.other_details.description
												?.message
										}
										defaultValue={
											item.other_details.description
										}
									/>
								</td>

								<td className="">
									<button
										className="button-primary-icon"
										onClick={() => remove(i)}
									>
										<i className="fas fa-trash"></i>
									</button>
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
			<div className="inner-container full">
				<button
					className="button-primary"
					onClick={handleSubmit(_saveInventoryCategory)}
				>
					Save
				</button>
			</div>
		</div>
	);
}

export default AddInventoryCategory;
